// removed by extract-text-webpack-plugin
module.exports = {"radar":"antd-pro_-_-scaffold-src-components-Charts-Radar-radar","legend":"antd-pro_-_-scaffold-src-components-Charts-Radar-legend","legendItem":"antd-pro_-_-scaffold-src-components-Charts-Radar-legendItem","split":"antd-pro_-_-scaffold-src-components-Charts-Radar-split","dot":"antd-pro_-_-scaffold-src-components-Charts-Radar-dot"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/Radar/index.less
// module id = 427
// module chunks = 0 1